import React from "react";
import { Route, Redirect } from 'react-router-dom';
import {connect} from "react-redux";
import {claimTypes} from "../constants/claim.constants";

const AuthRoute = ({ component: Component, claim, globalClaim, user, ...rest }) => {
    const claimAccess = user[`c_${claim}`] || null;

    return (
        globalClaim !== undefined ? (
            <Route {...rest} render={props => {
                return (
                    ( globalClaim === true && claimAccess !== claimTypes.NONE)
                        ? <Component {...props} />
                        : <Redirect to={'/not-permissions'} />
                );
            }} />
        ) : (
            <Route {...rest} render={props => {
                return (
                    (claimAccess !== claimTypes.NONE)
                        ? <Component {...props} />
                        : <Redirect to={'/not-permissions'} />
                );
            }} />
        )
    )
};

const mapStateToProps = state => {
    const {user} = state.authenticationReducer;
    return {
        user
    }
};

export default connect(mapStateToProps)(AuthRoute)
